import React, { useState, useEffect, useRef, useCallback } from "react";
import { Input, InputGroup, InputGroupAddon, InputGroupText } from "reactstrap";
//import interfaces from inter/index
import {
  IIdValuePairResponse,
  IPaiyaGift,
  IPaiyaGiftsListProps,
} from "interfaces/Index";
import { _ } from "utils/lib";
import ButtonComponent from "components/common/Button/ButtonComponent";
import DataTable from "components/common/DataTable/DataTable";
import {
  headerData,
  footerData,
  bodyDataAndKeyTypes,
  PAIYA_GIFT_TYPES,
} from "./PaiyaGiftsTableConstants";
import searchicon from "../../../assets/images/search-icon.svg";
import Toaster from "components/common/Toaster/Toaster";
import LoaderComponent from "components/common/Loader/Loader";
import { Can } from "config/Can";
import "./PaiyaGiftsList.scss";
import SearchableSelect from "components/common/SearchableSelect/SearchableSelect";

export const doAPIsearch = (
  val: any,
  pageScrollPosition: any,
  fetchPaiyaGifts: any,
  selectedType: any
) => {
  if (val.length >= 1) {
    pageScrollPosition.current = 0;
    fetchPaiyaGifts(val, selectedType.id);
  }
};

const PaiyaGiftsList: React.FunctionComponent<IPaiyaGiftsListProps> = (
  props: IPaiyaGiftsListProps
) => {
  let pageScrollPosition: any = useRef(props.currentListPosition);

  const [paiyaGiftsData, setPaiyaGiftsData] = useState<Array<IPaiyaGift>>([]);
  const [isSearch, setIsSearching] = useState(
    props.retainedSearchText ? true : false
  );
  const [searchTerm, setSearchTerm] = useState(props.retainedSearchText);

  const [showToaster, setToaster] = useState({
    isVisible: false,
    message: "",
    isError: false,
  });

  const [selectedType, setSelectedType] = useState<any>(PAIYA_GIFT_TYPES[0]);

  useEffect(() => {
    const { paiyaGifts } = props;
    setPaiyaGiftsData(paiyaGifts);
  }, [props.paiyaGifts]);

  useEffect(() => {
    if (props.isPaiyaGiftCreated) {
      let message = "Paiya Gift created successfully";
      handleToaster(false, message);
    } else if (props.isError) {
      const { error } = props;

      handleToaster(true, (error! as any).errors);
    }
  }, [props.isPaiyaGiftCreated, props.isError]);

  const debounceSearch = useCallback(
    _.debounce(
      (value: any, type) =>
        doAPIsearch(value, pageScrollPosition, props.fetchPaiyaGifts, type),
      1000
    ),
    []
  );

  const handleSearchInputChange = (e: any) => {
    const value = e.target.value;
    setSearchTerm(value);
    debounceSearch(value, selectedType);

    if (value.length > 0 && !isSearch) {
      setIsSearching(true);
    }
  };

  const handleSelectedTypeChange = (e: IIdValuePairResponse) => {
    const { fetchPaiyaGifts } = props;
    fetchPaiyaGifts(searchTerm, e.id);
    setSelectedType(e);
  };

  const handleToaster = (error: boolean, message: string) => {
    setToaster({
      isVisible: true,
      message: message,
      isError: error,
    });
  };

  return (
    <div className="paiya-gifts-list-container">
      {props.isLoading && <LoaderComponent />}
      <Toaster
        showToaster={showToaster.isVisible}
        toasterClass={
          showToaster.isError
            ? "toaster toaster-bg-danger"
            : "toaster toaster-bg-success"
        }
      >
        {showToaster.message || ""}
      </Toaster>
      <section className="relative container sticky-top">
        <section className="row">
          <section className="col-8">
            <InputGroup>
              <InputGroupAddon addonType="prepend">
                <InputGroupText>
                  <img src={searchicon} alt="close" />
                </InputGroupText>
              </InputGroupAddon>
              <Input
                className="search-input"
                placeholder="Search by title"
                onChange={handleSearchInputChange}
                value={searchTerm}
              />
              <div className="input-group-append">
                <SearchableSelect
                  id="title"
                  isSearchable={true}
                  options={PAIYA_GIFT_TYPES}
                  onChange={handleSelectedTypeChange}
                  selectedValue={selectedType}
                />
              </div>
            </InputGroup>
          </section>
          <section className="col-2 add-section">
            <Can I="create" a="gift">
              <ButtonComponent
                buttonText="Create a Gift"
                onClickHandler={() =>
                  props.addUpdatePageHandler(
                    selectedType,
                    searchTerm,
                    window.pageYOffset
                  )
                }
                buttonClass="btn-primary btn btn-secondary button-medium"
              />
            </Can>
          </section>
        </section>
      </section>
      {/* <Can I="read" a="zone"> */}
      <DataTable
        tableId="paiya-gift-list"
        tableHeaderData={headerData}
        tableFooterData={footerData}
        tableBodyDataTypes={bodyDataAndKeyTypes}
        tableBodyRowData={paiyaGiftsData}
        noSearchResultFlag={isSearch}
      />
      {/* </Can> */}
    </div>
  );
};

export default PaiyaGiftsList;
